export default __webpack_public_path__ + "static/bar-with-labels-39c74c4c032cd9207943bff42609b839.png";